import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

/* ── Avatar ─────────────────────────────────────────────────── */
export function Avatar({ name, size, url }) {
  var nm   = name || '';
  var sz   = size || 36;
  var cols = ['#4f46e5','#7c3aed','#db2777','#059669','#d97706','#dc2626','#2563eb'];
  var bg   = cols[nm.charCodeAt(0) % cols.length];
  var init = (nm.split(' ').map(function(w){ return w[0]; }).join('').toUpperCase().slice(0,2)) || 'U';
  if (url) return <img src={url} alt={nm} style={{ width:sz,height:sz,borderRadius:'50%',objectFit:'cover',flexShrink:0,border:'2px solid #e2e8f0' }} />;
  return <div style={{ width:sz,height:sz,borderRadius:'50%',background:bg,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,fontSize:sz*0.36,flexShrink:0 }}>{init}</div>;
}

var ROLE_COLORS  = { student:'#2563eb', alumni:'#059669', teacher:'#7c3aed', admin:'#d97706', superadmin:'#dc2626' };
var NOTIF_ICONS  = { job:'💼', event:'📅', message:'💬', registration:'👤', approval:'✅', system:'🔔' };

/* ── Global Search ──────────────────────────────────────────── */
function GlobalSearch(props) {
  var onNavigate = props.onNavigate;

  var qs       = useState('');        var q = qs[0];          var setQ = qs[1];
  var ds       = useState(null);      var data = ds[0];       var setData = ds[1];
  var ls       = useState(false);     var loading = ls[0];    var setLoading = ls[1];
  var os       = useState(false);     var open = os[0];       var setOpen = os[1];
  var wrapRef  = useRef(null);
  var timerRef = useRef(null);

  useEffect(function() {
    function onOutside(evt) {
      if (wrapRef.current && !wrapRef.current.contains(evt.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onOutside);
    return function() { document.removeEventListener('mousedown', onOutside); };
  }, []);

  function runSearch(val) {
    if (!val || val.trim().length < 2) { setData(null); setOpen(false); return; }
    setLoading(true);
    Promise.allSettled([
      API.get('/jobs?limit=20').then(function(resp) {
        var lc = val.toLowerCase();
        return (resp.data.jobs || []).filter(function(j) {
          return (j.title||'').toLowerCase().includes(lc) || (j.company||'').toLowerCase().includes(lc);
        }).slice(0,3);
      }),
      API.get('/events?limit=50').then(function(resp) {
        var lc = val.toLowerCase();
        return (resp.data.events || []).filter(function(ev) {
          return (ev.title||'').toLowerCase().includes(lc);
        }).slice(0,3);
      }),
      API.get('/profiles/alumni/search?search=' + encodeURIComponent(val) + '&limit=3')
        .then(function(resp) { return resp.data.profiles || []; })
        .catch(function() { return []; }),
    ]).then(function(settled) {
      setData({
        jobs:   settled[0].status === 'fulfilled' ? settled[0].value : [],
        events: settled[1].status === 'fulfilled' ? settled[1].value : [],
        users:  settled[2].status === 'fulfilled' ? settled[2].value : [],
      });
      setOpen(true);
    }).catch(function(err) {
      console.error('search error', err);
    }).finally(function() {
      setLoading(false);
    });
  }

  function handleChange(evt) {
    var val = evt.target.value;
    setQ(val);
    clearTimeout(timerRef.current);
    if (!val.trim()) { setData(null); setOpen(false); return; }
    timerRef.current = setTimeout(function() { runSearch(val); }, 350);
  }

  function handleFocus() { if (data) setOpen(true); }
  function handleFocusIn(evt) { evt.target.style.borderColor='#2563eb'; evt.target.style.background='#fff'; }
  function handleBlur(evt)    { evt.target.style.borderColor='#e2e8f0'; evt.target.style.background='#f8fafc'; }

  var total = data ? (data.jobs.length + data.events.length + data.users.length) : 0;

  var dropdownStyle = {
    position:'absolute',top:'calc(100% + 6px)',left:0,right:0,
    background:'#fff',borderRadius:16,
    boxShadow:'0 8px 32px rgba(0,0,0,0.15)',
    border:'1px solid #e2e8f0',zIndex:200,
    overflow:'hidden',maxHeight:400,overflowY:'auto',
  };

  function navTo(tab) { return function() { onNavigate(tab); setOpen(false); setQ(''); }; }
  function hoverIn(evt)  { evt.currentTarget.style.background='#f8fafc'; }
  function hoverOut(evt) { evt.currentTarget.style.background='transparent'; }

  var btnStyle = {
    width:'100%',display:'flex',alignItems:'center',gap:10,
    padding:'10px 16px',border:'none',background:'transparent',
    cursor:'pointer',textAlign:'left',
  };

  return (
    <div ref={wrapRef} style={{ flex:1,maxWidth:420,position:'relative' }}>
      <span style={{ position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',fontSize:14,color:'#94a3b8',pointerEvents:'none' }}>🔍</span>
      <input
        value={q}
        onChange={handleChange}
        onFocus={handleFocus}
        onFocusCapture={handleFocusIn}
        onBlur={handleBlur}
        placeholder="Search jobs, events, alumni..."
        style={{ width:'100%',padding:'9px 12px 9px 34px',borderRadius:12,border:'1.5px solid #e2e8f0',background:'#f8fafc',fontSize:13,color:'#374151',outline:'none',boxSizing:'border-box' }}
      />
      {loading && <span style={{ position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',fontSize:12,color:'#94a3b8' }}>⏳</span>}

      {open && data && (
        <div style={dropdownStyle}>
          {total === 0 ? (
            <div style={{ padding:24,textAlign:'center',color:'#94a3b8' }}>
              <div style={{ fontSize:32,marginBottom:8 }}>🔍</div>
              <p style={{ fontSize:13,fontWeight:600,color:'#64748b',margin:0 }}>No results for &ldquo;{q}&rdquo;</p>
              <p style={{ fontSize:12,color:'#94a3b8',marginTop:4 }}>Try a different keyword</p>
            </div>
          ) : (
            <div>
              {data.jobs.length > 0 && (
                <div>
                  <div style={{ padding:'8px 16px 4px',fontSize:11,fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:1 }}>💼 Jobs</div>
                  {data.jobs.map(function(job) {
                    return (
                      <button key={job._id} onClick={navTo('jobs')} style={btnStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                        <div style={{ width:36,height:36,borderRadius:10,background:'#eff6ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0 }}>💼</div>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontWeight:600,fontSize:13,color:'#1e293b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{job.title}</div>
                          <div style={{ fontSize:11,color:'#64748b' }}>{job.company} · {job.type}</div>
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
              {data.events.length > 0 && (
                <div>
                  <div style={{ padding:'8px 16px 4px',fontSize:11,fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:1,borderTop:data.jobs.length>0?'1px solid #f1f5f9':'none' }}>📅 Events</div>
                  {data.events.map(function(ev) {
                    return (
                      <button key={ev._id} onClick={navTo('events')} style={btnStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                        <div style={{ width:36,height:36,borderRadius:10,background:'#f5f3ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0 }}>📅</div>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontWeight:600,fontSize:13,color:'#1e293b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{ev.title}</div>
                          <div style={{ fontSize:11,color:'#64748b' }}>{new Date(ev.date).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})} · {ev.category}</div>
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
              {data.users.length > 0 && (
                <div>
                  <div style={{ padding:'8px 16px 4px',fontSize:11,fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:1,borderTop:'1px solid #f1f5f9' }}>👤 Alumni</div>
                  {data.users.map(function(usr) {
                    var uid = usr._id || usr.userId;
                    var uname = usr.fullName || usr.name || '?';
                    return (
                      <button key={uid} onClick={navTo('alumni')} style={btnStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                        <div style={{ width:36,height:36,borderRadius:'50%',background:'#ecfdf5',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,color:'#059669',fontSize:14,flexShrink:0 }}>{uname[0]}</div>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontWeight:600,fontSize:13,color:'#1e293b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{uname}</div>
                          <div style={{ fontSize:11,color:'#64748b' }}>{usr.currentCompany || usr.department || 'Alumni'}</div>
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* ── Notification Panel ─────────────────────────────────────── */
function NotificationPanel(props) {
  var onNavigate = props.onNavigate;

  var os = useState(false);      var open = os[0];      var setOpen = os[1];
  var ns = useState([]);         var notifs = ns[0];    var setNotifs = ns[1];
  var us = useState(0);          var unread = us[0];    var setUnread = us[1];
  var ls = useState(false);      var loading = ls[0];   var setLoading = ls[1];
  var panelRef = useRef(null);

  useEffect(function() {
    function onOutside(evt) {
      if (panelRef.current && !panelRef.current.contains(evt.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onOutside);
    return function() { document.removeEventListener('mousedown', onOutside); };
  }, []);

  useEffect(function() {
    function fetchCount() {
      API.get('/notifications').then(function(resp) {
        setNotifs(resp.data.notifications || []);
        setUnread(resp.data.unreadCount || 0);
      }).catch(function() {});
    }
    fetchCount();
    var timer = setInterval(fetchCount, 30000);
    return function() { clearInterval(timer); };
  }, []);

  function toggleOpen() {
    var next = !open;
    setOpen(next);
    if (next) {
      setLoading(true);
      API.get('/notifications').then(function(resp) {
        setNotifs(resp.data.notifications || []);
        setUnread(resp.data.unreadCount || 0);
      }).catch(function(){}).finally(function() { setLoading(false); });
    }
  }

  function markAll() {
    API.put('/notifications/read-all').catch(function(){});
    setNotifs(function(prev) { return prev.map(function(x) { return Object.assign({},x,{isRead:true}); }); });
    setUnread(0);
  }

  function handleNotifClick(notif) {
    if (!notif.isRead) {
      API.put('/notifications/' + notif._id + '/read').catch(function(){});
      setNotifs(function(prev) {
        return prev.map(function(x) { return x._id === notif._id ? Object.assign({},x,{isRead:true}) : x; });
      });
      setUnread(function(u) { return Math.max(0, u - 1); });
    }
    if (notif.link) onNavigate(notif.link);
    setOpen(false);
  }

  function timeAgo(d) {
    var diff = Date.now() - new Date(d).getTime();
    if (diff < 60000)    return 'just now';
    if (diff < 3600000)  return Math.floor(diff/60000) + 'm ago';
    if (diff < 86400000) return Math.floor(diff/3600000) + 'h ago';
    return Math.floor(diff/86400000) + 'd ago';
  }

  function bellHoverIn(evt)  { evt.currentTarget.style.background='#f1f5f9'; }
  function bellHoverOut(evt) { evt.currentTarget.style.background='transparent'; }
  function rowHoverIn(evt)   { evt.currentTarget.style.background='#f8fafc'; }

  return (
    <div ref={panelRef} style={{ position:'relative' }}>
      <button onClick={toggleOpen} onMouseEnter={bellHoverIn} onMouseLeave={bellHoverOut}
        style={{ background:'transparent',border:'none',cursor:'pointer',position:'relative',padding:'6px 8px',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center' }}>
        <span style={{ fontSize:20 }}>🔔</span>
        {unread > 0 && (
          <span style={{ position:'absolute',top:2,right:2,background:'#ef4444',color:'#fff',borderRadius:999,fontSize:10,fontWeight:800,minWidth:18,height:18,display:'flex',alignItems:'center',justifyContent:'center',border:'2px solid #fff',padding:'0 3px' }}>
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </button>

      {open && (
        <div style={{ position:'absolute',top:'calc(100% + 8px)',right:0,width:340,background:'#fff',borderRadius:16,boxShadow:'0 8px 32px rgba(0,0,0,0.15)',border:'1px solid #e2e8f0',zIndex:200,overflow:'hidden' }}>
          <div style={{ padding:'14px 16px',borderBottom:'1px solid #f1f5f9',display:'flex',alignItems:'center',justifyContent:'space-between' }}>
            <div style={{ display:'flex',alignItems:'center',gap:8 }}>
              <span style={{ fontSize:16,fontWeight:800,color:'#1e293b' }}>Notifications</span>
              {unread > 0 && <span style={{ background:'#ef4444',color:'#fff',borderRadius:999,fontSize:11,fontWeight:700,padding:'1px 8px' }}>{unread}</span>}
            </div>
            {unread > 0 && (
              <button onClick={markAll} style={{ fontSize:12,color:'#2563eb',fontWeight:600,background:'none',border:'none',cursor:'pointer',padding:'4px 8px',borderRadius:6 }}>Mark all read</button>
            )}
          </div>
          <div style={{ maxHeight:340,overflowY:'auto' }}>
            {loading ? (
              <div style={{ padding:32,textAlign:'center',color:'#94a3b8',fontSize:13 }}>⏳ Loading...</div>
            ) : notifs.length === 0 ? (
              <div style={{ padding:32,textAlign:'center',color:'#94a3b8' }}>
                <div style={{ fontSize:40,marginBottom:8 }}>🔔</div>
                <p style={{ fontSize:13,fontWeight:600,color:'#64748b',margin:0 }}>All caught up!</p>
                <p style={{ fontSize:12,marginTop:4 }}>No notifications yet</p>
              </div>
            ) : notifs.map(function(notif) {
              var icon = NOTIF_ICONS[notif.type] || '🔔';
              var rowBg = notif.isRead ? 'transparent' : '#eff6ff';
              var iconBg = notif.isRead ? '#f1f5f9' : '#dbeafe';
              return (
                <button key={notif._id}
                  onClick={function() { handleNotifClick(notif); }}
                  onMouseEnter={rowHoverIn}
                  onMouseLeave={function(evt) { evt.currentTarget.style.background = notif.isRead ? 'transparent' : '#eff6ff'; }}
                  style={{ width:'100%',display:'flex',alignItems:'flex-start',gap:12,padding:'12px 16px',border:'none',background:rowBg,cursor:'pointer',textAlign:'left',borderBottom:'1px solid #f8fafc' }}>
                  <div style={{ width:36,height:36,borderRadius:10,background:iconBg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0 }}>{icon}</div>
                  <div style={{ flex:1,minWidth:0 }}>
                    <div style={{ fontWeight:notif.isRead?500:700,fontSize:13,color:'#1e293b',lineHeight:1.4,marginBottom:2 }}>{notif.title}</div>
                    <div style={{ fontSize:12,color:'#64748b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{notif.body}</div>
                    <div style={{ fontSize:11,color:'#94a3b8',marginTop:3 }}>{timeAgo(notif.createdAt)}</div>
                  </div>
                  {!notif.isRead && <div style={{ width:8,height:8,borderRadius:'50%',background:'#2563eb',flexShrink:0,marginTop:4 }} />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

/* ── NAVBAR ─────────────────────────────────────────────────── */
export default function Navbar(props) {
  var onMenuToggle = props.onMenuToggle;
  var onNavigate   = props.onNavigate || function() {};
  var auth = useAuth();
  var user = auth.user;
  var roleColor = ROLE_COLORS[user && user.role] || '#2563eb';

  return (
    <div style={{ height:64,background:'#fff',borderBottom:'1px solid #e2e8f0',display:'flex',alignItems:'center',padding:'0 16px',flexShrink:0,gap:10,position:'sticky',top:0,zIndex:100 }}>
      <button onClick={onMenuToggle} aria-label="Toggle menu"
        style={{ background:'none',border:'none',cursor:'pointer',fontSize:22,color:'#64748b',display:'flex',alignItems:'center',padding:6,borderRadius:8,flexShrink:0 }}>
        ☰
      </button>

      <div className="navbar-search" style={{ display:'none',flex:1 }}>
        <GlobalSearch onNavigate={onNavigate} />
      </div>

      <div style={{ flex:1 }} />

      <div style={{ display:'flex',alignItems:'center',gap:8,flexShrink:0 }}>
        <NotificationPanel onNavigate={onNavigate} />
        <Avatar name={user && user.name} size={34} url={user && user.avatar} />
        <div className="navbar-userinfo" style={{ display:'none',lineHeight:1.3 }}>
          <div style={{ fontWeight:700,fontSize:13,color:'#1e293b',whiteSpace:'nowrap',maxWidth:130,overflow:'hidden',textOverflow:'ellipsis' }}>{user && user.name}</div>
          <div style={{ fontSize:10,color:'#fff',fontWeight:600,background:roleColor,padding:'1px 7px',borderRadius:999,textTransform:'capitalize',display:'inline-block' }}>{user && user.role}</div>
        </div>
      </div>

      <style>{`
        @media(min-width:640px)  { .navbar-userinfo { display:block !important; } }
        @media(min-width:769px)  { .navbar-search   { display:block !important; } }
      `}</style>
    </div>
  );
}
